import React, { useState } from "react";
import {
    FaChevronDown, FaChevronUp, FaSearch, FaDownload, FaEdit, FaTrashAlt, FaPlus, FaUserShield, FaExclamationTriangle, FaTimes
} from "react-icons/fa";
import { AiOutlineSafetyCertificate, AiFillWarning } from "react-icons/ai";
import './UserGuidelines.css';


const LegalAdminUserView = () => {
    const [openSection, setOpenSection] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [sections, setSections] = useState([
        {
            id: "terms",
            title: "Terms & Conditions",
            icon: <AiOutlineSafetyCertificate />,
            content: "Provide accurate and honest profile details..."
        },
        {
            id: "guidelines",
            title: "Community Guidelines",
            icon: <AiFillWarning />,
            content: "Be respectful; harassment will not be tolerated..."
        },
        {
            id: "refund",
            title: "Refund & Cancellation Policy",
            icon: <FaUserShield />,
            content: "Refunds are available within 7 days of purchase..."
        },
        {
            id: "report",
            title: "Report & Block Users",
            icon: <FaExclamationTriangle />,
            content: "Report fake profiles or suspicious activity..."
        },
        {
            id: "delete",
            title: "Account Deletion",
            icon: <FaTrashAlt />,
            content: "Go to Profile Settings & select 'Delete Account'..."
        }
    ]);
    const [newSection, setNewSection] = useState({ title: "", content: "" });
    const [editIndex, setEditIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    const handleDownload = () => {
        alert("Downloading Legal & Administrative Policy PDF...");
    };

    const handleAddSection = () => {
        if (newSection.title.trim() && newSection.content.trim()) {
            setSections([...sections, {
                id: new Date().getTime().toString(),
                title: newSection.title,
                content: newSection.content,
                icon: <FaPlus />
            }]);
            setNewSection({ title: "", content: "" });
        }
    };

    const handleEditSection = (index) => {
        setNewSection({ title: sections[index].title, content: sections[index].content });
        setEditIndex(index);
        setIsModalOpen(true);
    };

    const handleUpdateSection = () => {
        if (editIndex !== null) {
            const updatedSections = [...sections];
            updatedSections[editIndex] = { ...updatedSections[editIndex], ...newSection };
            setSections(updatedSections);
            setNewSection({ title: "", content: "" });
            setEditIndex(null);
            setIsModalOpen(false);
        }
    };

    const handleDeleteSection = (index) => {
        setSections(sections.filter((_, i) => i !== index));
    };

    return (
        <>

            <div className="legal-containerLL190">
                <aside className="sidebarLL1">
                    <h3>Legal Sections</h3>
                    <ul>
                        {sections.map((section, index) => (
                            <li key={section.id} onClick={() => toggleSection(section.id)}>
                                {section.icon} {section.title}
                            </li>
                        ))}
                    </ul>

                </aside>

                <div className="content-areaLL1">
                    <input
                        type="text"
                        placeholder="🔍 Search Legal Content..."
                        className="searchBoxLL1"
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />

                    <div className="grid-layoutLL1">
                        {sections
                            .filter((section) => section.title.toLowerCase().includes(searchQuery.toLowerCase()))
                            .map((section, index) => (
                                <div key={section.id} className="section-cardLL1">
                                    <button className="sectionHeaderLL1" onClick={() => toggleSection(section.id)}>
                                        {section.icon} {section.title} {openSection === section.id ? <FaChevronUp /> : <FaChevronDown />}
                                    </button>
                                    {openSection === section.id && (
                                        <div className="sectionContentLL1">
                                            <p>{section.content}</p>
                                            <button className="editBtnLL1" onClick={() => handleEditSection(index)}>
                                                <FaEdit /> Edit
                                            </button>
                                            <button className="deleteBtnLL1" onClick={() => handleDeleteSection(index)}>
                                                <FaTrashAlt /> Delete
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>

                    {/* Modal Popup for Editing */}
                    {isModalOpen && (
                        <div className="modal-overlay">
                            <div className="modal-content">
                                <h3>Edit Section</h3>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        placeholder="Section Title"
                                        value={newSection.title}
                                        onChange={(e) => setNewSection({ ...newSection, title: e.target.value })}
                                    />
                                    <FaEdit className="edit-icon" />
                                </div>

                                <div className="textarea-container">
                                    <textarea
                                        placeholder="Section Content"
                                        value={newSection.content}
                                        onChange={(e) => setNewSection({ ...newSection, content: e.target.value })}
                                    ></textarea>
                                    <FaEdit className="edit-icon" />
                                </div>

                                <button className="updateBtnLL1" onClick={handleUpdateSection}>Update Section</button>
                                <a className="closeBtnLL1" onClick={() => setIsModalOpen(false)}><FaTimes /></a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default LegalAdminUserView;